import './assets/index37.css';var z = Object.defineProperty, U = Object.defineProperties;
var V = Object.getOwnPropertyDescriptors;
var g = Object.getOwnPropertySymbols;
var y = Object.prototype.hasOwnProperty, x = Object.prototype.propertyIsEnumerable;
var B = (o, e, a) => e in o ? z(o, e, { enumerable: !0, configurable: !0, writable: !0, value: a }) : o[e] = a, i = (o, e) => {
  for (var a in e || (e = {}))
    y.call(e, a) && B(o, a, e[a]);
  if (g)
    for (var a of g(e))
      x.call(e, a) && B(o, a, e[a]);
  return o;
}, l = (o, e) => U(o, V(e));
var f = (o, e) => {
  var a = {};
  for (var t in o)
    y.call(o, t) && e.indexOf(t) < 0 && (a[t] = o[t]);
  if (o != null && g)
    for (var t of g(o))
      e.indexOf(t) < 0 && x.call(o, t) && (a[t] = o[t]);
  return a;
};
import { jsxs as F, jsx as m } from "react/jsx-runtime";
import { forwardRef as I } from "react";
import { u as T, B as W, h as X, c as Z } from "./factory-ueRxoNOV.js";
import { e as $, c as u } from "./get-size-Bc1Pz5yf.js";
import { c as q } from "./create-vars-resolver-Bzbn9G-G.js";
import { u as A } from "./use-styles-DToiHEa6.js";
import { p as D } from "./polymorphic-factory-DufevJAl.js";
var N = { root: "m_347db0ec", "root--dot": "m_fbd81e3d", label: "m_5add502a", section: "m_91fdda9b" };
const E = {}, G = q(
  (o, { radius: e, color: a, gradient: t, variant: s, size: d, autoContrast: c }) => {
    const r = o.variantColorResolver({
      color: a || o.primaryColor,
      theme: o,
      gradient: t,
      variant: s || "filled",
      autoContrast: c
    });
    return {
      root: {
        "--badge-height": u(d, "badge-height"),
        "--badge-padding-x": u(d, "badge-padding-x"),
        "--badge-fz": u(d, "badge-fz"),
        "--badge-radius": e === void 0 ? void 0 : $(e),
        "--badge-bg": a || s ? r.background : void 0,
        "--badge-color": a || s ? r.color : void 0,
        "--badge-bd": a || s ? r.border : void 0,
        "--badge-dot-color": s === "dot" ? X(a, o) : void 0
      }
    };
  }
), h = D((o, e) => {
  const a = T("Badge", E, o), v = a, {
    classNames: t,
    className: s,
    style: d,
    styles: c,
    unstyled: r,
    vars: R,
    radius: L,
    color: M,
    gradient: O,
    leftSection: p,
    rightSection: b,
    children: S,
    variant: _,
    fullWidth: w,
    autoContrast: Q,
    circle: P,
    mod: j
  } = v, k = f(v, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "radius",
    "color",
    "gradient",
    "leftSection",
    "rightSection",
    "children",
    "variant",
    "fullWidth",
    "autoContrast",
    "circle",
    "mod"
  ]), n = A({
    name: "Badge",
    props: a,
    classes: N,
    className: s,
    style: d,
    classNames: t,
    styles: c,
    unstyled: r,
    vars: R,
    varsResolver: G
  });
  return /* @__PURE__ */ F(
    W,
    l(i(l(i({
      variant: _,
      mod: [
        {
          block: w,
          circle: P,
          "with-right-section": !!b,
          "with-left-section": !!p
        },
        j
      ]
    }, n("root", { variant: _ })), {
      ref: e
    }), k), {
      children: [
        p && /* @__PURE__ */ m("span", l(i({}, n("section")), { "data-position": "left", children: p })),
        /* @__PURE__ */ m("span", l(i({}, n("label")), { children: S })),
        b && /* @__PURE__ */ m("span", l(i({}, n("section")), { "data-position": "right", children: b }))
      ]
    })
  );
});
h.classes = N;
h.displayName = "@mantine/core/Badge";
const H = "Badge-module__root___IZCUX", J = "Badge-module__capital___-VPzU", C = {
  root: H,
  capital: J
}, K = I((c, d) => {
  var r = c, {
    children: o,
    variant: e = "light",
    className: a,
    uppercase: t = !0
  } = r, s = f(r, [
    "children",
    "variant",
    "className",
    "uppercase"
  ]);
  return /* @__PURE__ */ m(
    h,
    l(i({
      ref: d,
      "data-variant": e,
      className: Z(C.root, a, {
        [C.capital]: !t
      })
    }, s), {
      children: o
    })
  );
});
K.displayName = "Badge";
export {
  K as B,
  C as a
};
